export const ModalButtonActionType = Object.freeze({
	Cancel: 'Cancel',
	Confirm: 'Confirm',
	End: 'End', // e.g. end the tutorial
	Ok: 'OK',
	Refresh: 'Refresh',
});
